import { Component, inject } from '@angular/core';

import { UnsavedChangesService } from '@core/services/unsaved-changes.service';

import { Modal } from '@shared/components/modal/modal';

/** The question behind `unsavedChangesGuard`: leave this page and lose the edits, or stay and save them. */
@Component({
  selector: 'app-leave-confirm-dialog',
  imports: [Modal],
  template: `
    @if (unsaved.asking()) {
      <app-modal title="Ungespeicherte Änderungen" (closed)="unsaved.answerLeave(false)">
        <p>Auf dieser Seite gibt es Änderungen, die noch nicht gespeichert sind. Wenn Sie die Seite verlassen, gehen sie verloren.</p>
        <div class="leave-actions">
          <button type="button" class="btn-primary" (click)="unsaved.answerLeave(false)">Auf der Seite bleiben</button>
          <button type="button" class="btn-danger" (click)="unsaved.answerLeave(true)">Verwerfen und verlassen</button>
        </div>
      </app-modal>
    }
  `,
  styles: `
    .leave-actions {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-end;
      gap: var(--s-3);
      margin-top: var(--s-5);
    }
  `,
})
export class LeaveConfirmDialog {
  protected readonly unsaved = inject(UnsavedChangesService);
}
